const getErrorMessage = (errors, field) => {
  const error = errors.find(err => err.path.includes(field));
  return error ? error.message : null;
};

export const ErrorMessage = ({ errors, field }) => {
  const errorMessage = getErrorMessage(errors, field);
  return errorMessage ? <p style={{ color: 'red' }}>{errorMessage}</p> : null;
};